import affiliateService from '../Services/affiliateService';

/**
 * Navigation utilities that automatically handle affiliate IDs
 */

/**
 * Navigate to a URL with affiliate ID automatically appended
 * @param {object} history - React Router history object
 * @param {string} path - The path to navigate to
 * @param {string} search - Current URL search string (optional)
 */
export const navigateWithAffiliate = (history, path, search = '') => {
  const urlWithAffiliate = affiliateService.buildUrlWithAffiliate(path, search);
  history.push(urlWithAffiliate);
};

/**
 * Navigate to a URL with stored affiliate ID
 * @param {object} history - React Router history object
 * @param {string} path - The path to navigate to
 */
export const navigateWithStoredAffiliate = (history, path) => {
  const urlWithAffiliate = affiliateService.buildUrlWithStoredAffiliate(path);
  history.push(urlWithAffiliate);
};

/**
 * Replace current URL with affiliate ID automatically appended
 * @param {object} history - React Router history object
 * @param {string} path - The path to navigate to
 * @param {string} search - Current URL search string (optional)
 */
export const replaceWithAffiliate = (history, path, search = '') => {
  const urlWithAffiliate = affiliateService.buildUrlWithAffiliate(path, search);
  history.replace(urlWithAffiliate);
};

/**
 * Replace current URL with stored affiliate ID
 * @param {object} history - React Router history object
 * @param {string} path - The path to navigate to
 */
export const replaceWithStoredAffiliate = (history, path) => {
  const urlWithAffiliate = affiliateService.buildUrlWithStoredAffiliate(path);
  history.replace(urlWithAffiliate);
};

/**
 * Get a URL with affiliate ID for external links or other uses
 * @param {string} path - The path
 * @param {string} search - Current URL search string (optional)
 * @returns {string} - URL with affiliate ID
 */
export const getUrlWithAffiliate = (path, search = '') => {
  return affiliateService.buildUrlWithAffiliate(path, search);
};

/**
 * Get a URL with stored affiliate ID
 * @param {string} path - The path
 * @returns {string} - URL with stored affiliate ID
 */
export const getUrlWithStoredAffiliate = (path) => {
  return affiliateService.buildUrlWithStoredAffiliate(path);
};
